<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <form class="modal-content" v-on:submit.prevent="handleUpdateInvoiceClick">
                <div class="block block-rounded block-transparent mb-0">
                    <div class="block-header block-header-default">
                        <h3 class="block-title">Edit Invoice</h3>
                        <div class="block-options">
                            <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close">
                                <i class="fa fa-fw fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div v-if="loading" class="block-content text-center">
                        <p class="h4 mb-4">Loading</p>
                    </div>
                    <div v-show="loading === false" class="block-content fs-sm">
                        <div class="mb-4">
                            <label class="form-label" for="f_description">Description</label>
                            <input v-model="invoice.description" type="text" class="form-control" id="f_description" />
                        </div>
                        <div class="mb-4">
                            <label class="form-label">Current Account Code</label>
                            <input v-model="invoice.account_code" type="text" class="form-control" readonly />
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-5">
                                <h6 class="ta-c">Assign Job</h6>
                                <div class="mb-4">
                                    <div class="mb-4">
                                        <label class="form-label" for="f_vehicle-uuid">Vehicle</label>
                                        <select class="form-control select2" id="f_vehicle-uuid" ref="vehicleUuid" :disabled="invoice.marked_as_internal === true">
                                        </select>
                                        <p v-if="vehicleAccountCode && invoice.marked_as_internal === false" class="text-center mt-1">New Account Code: {{ vehicleAccountCode }}</p>
                                    </div>
                                    <div class="mb-4">
                                        <label class="form-label" for="f_job-uuid">Job</label>
                                        <select class="form-control select2" id="f_job-uuid" ref="jobUuid" :disabled="invoice.marked_as_internal === true || chosenVehicle === null">
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-2 ta-c m-a">
                                <label class="m-a">OR</label>
                            </div>
                            <div class="col-12 col-md-5 ta-c m-a">
                                <div class="mb-4 mt-4">
                                    <input v-model="invoice.marked_as_internal" id="f_mark-internal" type="checkbox" class="form-check-input">
                                    <label class="form-label" for="f_mark-internal">Mark as Internal</label>
                                </div>
                                <div class="mb-4">
                                    <label class="form-label" for="f_internal_account_code">Internal Account Code</label>
                                    <select
                                        v-model="internalAccountCode"
                                        class="form-select"
                                        :class="{'is-invalid': invoice.marked_as_internal === true && internalAccountCode === null}"
                                        id="f_internal_account_code"
                                        :disabled="invoice.marked_as_internal === false"
                                    >
                                        <option v-for="option in accountCodes" v-bind:value="option.id">
                                            {{ option.text }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="block-content block-content-full text-end bg-body">
                        <button type="button" class="btn btn-sm btn-alt-secondary me-1" data-bs-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-sm btn-success">Update</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal';
import { Eventbus } from '@/components/eventbus';

export default {
    props: {
        accountCodes: Array,
        defaultInternalAccountCode: String,
        routes: Object,
    },
    data () {
        return {
            loading: false,
            chosenVehicle: null,
            vehicleAccountCode: null,
            jobPicker: null,
            vehiclePicker: null,
            internalAccountCode: null,
            route: '',
            invoice: {
                accountCode: '',
                description: '',
                marked_as_internal: false,
            },
        }
    },
    mounted () {
        this.modal = new Modal(this.$refs.modal);

        Eventbus.on('edit-classics-purchase-invoice', (invoiceGuid) => {
            this.loading = true;
            this.route = this.routes.updateInvoiceRoute.replace('replace-me', invoiceGuid);
            axios.get(this.route)
                .then((response) => {
                    this.invoice = response.data;
                    if (this.accountCodes.some((code) => code.id == this.defaultInternalAccountCode)) {
                        this.internalAccountCode = this.defaultInternalAccountCode;
                    }
                    this.vehicleAccountCode = null;
                    this.loading = false;
                    this.modal.show();
                    setTimeout(this.createPickers, 50);
                });
        });
    },
    methods: {
        createPickers () {
            this.vehiclePicker = window.jQuery(this.$refs.vehicleUuid).select2({
                dropdownParent: this.$refs.modal,
                placeholder: 'Select vehicle',
                width: '100%',
                ajax: {
                    data: function(params) {
                        return {
                            search: params.term,
                            page: params.page
                        };
                    },
                    dataType: 'json',
                    delay: 250,
                    processResults: function(data) {
                        // why do we need to do this?
                        return {
                            results: data.data
                        };
                    },
                    url: this.routes.selectVehicleRoute,
                }
            }).on('select2:select', (ev) => {
                this.chosenVehicle = ev.params.data.id;
                this.vehicleAccountCode = ev.params.data.account_code;
                window.jQuery(this.$refs.jobUuid).val(null).trigger('change');
            });

            if (this.vehiclePicker.find('option').length) {
                this.vehiclePicker.find('option').remove();
            }

            this.jobPicker = window.jQuery(this.$refs.jobUuid).select2({
                dropdownParent: this.$refs.modal,
                placeholder: 'Assign Job',
                width: '100%',
                ajax: {
                    url: () => this.routes.selectJobsRoute.replace('replace-me', this.chosenVehicle),
                    data: function (params) {
                        return {
                            search: params.term,
                            page: params.page || 1
                        }
                    },
                    dataType: 'json',
                    delay: 250,
                    processResults: function(data, params) {
                        return {
                            results: data.data,
                            pagination: {
                                more: data.data.length === 10
                            }
                        };
                    },
                }
            });

            if (this.jobPicker.find('option').length) {
                this.jobPicker.find('option').remove();
            }

            if (this.invoice.job) {
                this.chosenVehicle = this.invoice.job.vehicle.uuid;
                this.vehiclePicker.append(window.jQuery('<option selected>' + this.invoice.job.vehicle.description + '</option>').val(this.invoice.job.vehicle.uuid));

                this.jobPicker.append(window.jQuery('<option selected>' + this.invoice.job.description + '</option>').val(this.invoice.job.uuid));

                this.vehiclePicker.trigger('change');
                this.jobPicker.trigger('change');
            }
        },
        handleUpdateInvoiceClick () {
            axios.post(this.route, {
                job_uuid: this.$refs.jobUuid.value ?? null,
                description: this.invoice.description ?? '',
                mark_internal: this.invoice.marked_as_internal === true,
                internal_account_code: this.internalAccountCode,
            }).then(({data}) => {
                if (data.success === false) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Failed to update the purchase invoice',
                        text: data.message,
                    });

                    return;
                }

                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: data.message,
                });
                this.modal.hide();
                Eventbus.emit('purchase-invoices-table-refresh');
                this.idForActiveInvoice = null;
            }).catch((e) => {
                console.error(e);
                Swal.fire({
                    icon: 'error',
                    title: 'Failed to update the invoice',
                    text: 'There was a problem whilst trying to update the purchase invoice',
                });
            });
        }
    }
}
</script>
